import { axiosApi } from '@accor/customer-core'
import { POST_COMPANY_ORDERS } from '@/constants/urls'
import type { CompanyOrdersByCompanyIdResponse } from '@/types/companyOrders.types'
import type { AxiosResponse } from 'axios'

export enum CompanyOrdersQueryParamsOperator {
  GREATER_THAN = '>',
  LESS_THAN = '<',
  GREATER_THAN_OR_EQUAL = '>=',
  LESS_THAN_OR_EQUAL = '<='
}

export enum CompanyOrdersSortOrdering {
  ASC = 'ASC',
  DESC = 'DESC'
}
export interface CompanyOrdersQueryParams {
  pageSize?: number
  sort?: {
    field: string
    ordering: CompanyOrdersSortOrdering
  }
  filters?: {
    minArrivalDate?: {
      value: string
      operator: CompanyOrdersQueryParamsOperator
    }
    maxDepartureDate?: {
      value: string
      operator: CompanyOrdersQueryParamsOperator
    }
  }
}

export const getCompanyOrdersByCompanyId = async (
  companyId: string,
  params?: CompanyOrdersQueryParams,
  signal?: AbortSignal
): Promise<AxiosResponse<CompanyOrdersByCompanyIdResponse>> =>
  await axiosApi.post(POST_COMPANY_ORDERS(companyId), params, { signal })
